module.exports = __webpack_public_path__ + "img/tag-user.3a13844d.svg";